import React, { Component } from 'react';
import Urls from '../urls/Urls';
import './DragDropStreetViewButton.css';
import EfficientMoveCycle from '../ui_core/EfficientMoveCycle';
import getAbsolute from '../ui_core/getAbsolute';
import DragDropType from '../enums/DragDropType';
import IDragDropRecipient from '../interfaces/IDragDropRecipient';
import Tooltip from './Tooltip';

export default class DragDropStreetViewButton extends Component {
	constructor(props){
		super(props)
		const {showDefaultOutside360, getDragDropRecipient} = props;
		this._callbackShowDefaultOutside360= showDefaultOutside360;
		this._getDragDropRecipient = getDragDropRecipient;
		this._handleClick=this._handleClick.bind(this);
		this._setElementPosition= this._setElementPosition.bind(this);
		this._onDragStart = this._onDragStart.bind(this);
		this._onDragMove = this._onDragMove.bind(this);
		this._onDragEnd = this._onDragEnd.bind(this);
		this._setImage = this._setImage.bind(this);
		this._getImageUrl = this._getImageUrl.bind(this);
		this._elementRef = React.createRef();
		this._imgRef = React.createRef();
		this._offsets = null;
		this._moving = false;
	}
	componentDidMount(){
		this._iDragDropRecipient = this._getDragDropRecipient();
		IDragDropRecipient.validate(this._iDragDropRecipient);
		this._efficientMoveCycle = new EfficientMoveCycle({element:this._elementRef.current, stopPropagation:false, preventDefault:true,
		onStart:this._onDragStart, onMove:this._onDragMove, onEnd:this._onDragEnd, friendlyXY:true});
		Tooltip.register({
			element:this._elementRef.current, 
			text:"Drag & drop to view street scene"
		});
	}
	_onDragStart(e){
		const element = this._elementRef.current;
		if(!element)return;
		this._moving = false;
		const absolutePosition = getAbsolute(element);
		element.classList.add('dragging');
		this._setImage(this._imgRef.current, true);
		this._offsets = [-element.offsetWidth/2, -element.offsetHeight/2];
		this._setElementPosition(element, absolutePosition.left, absolutePosition.top);
	}
	_setImage(img, dragging){
		img.src = this._getImageUrl(dragging);
	}
	_getImageUrl(dragging){
		return Urls.assets+(dragging?'icons/UI_Button_Walkmode_Selected.png':'icons/UI_Button_Walkmode.png');
	}
	_setElementPosition(element, x, y){
		element.style.left=`${x}px`;
		element.style.top=`${y}px`;
	}
	_onDragMove(e){
		this._moving = true;
		this._setElementPosition(this._elementRef.current, e.x+this._offsets[0], e.y+this._offsets[1]);
		this._iDragDropRecipient.onDragging({type:DragDropType.STREET_VIEW_BUTTON, x:e.x, y:e.y});
	}
	_onDragEnd(e){
		const element = this._elementRef.current;
		element.classList.remove('dragging');
		this._setImage(this._imgRef.current, false);
		element.style.left=`0px`;
		element.style.top=`0px`;
		this._iDragDropRecipient.onDrop({type:DragDropType.STREET_VIEW_BUTTON, x:e.x, y:e.y});
	}
	componentDidUpdate(previousProps){
		
	}
	_handleClick(e){
		if(this._moving)return;
		this._callbackShowDefaultOutside360();
	}
	render() {
		let className = "drag-drop-street-view-button";
	return (<button className={className} onClick={this._handleClick} ref={this._elementRef}>
					<img ref={this._imgRef} src={this._getImageUrl(false)} />
			</button>);
	}
}
